import { ArrowRight, CheckCircle2 } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function LoanHero({
  badge,
  title,
  description,
  highlights = [],
  image,
  primaryButtonText = "Get Free Consultation",
  secondaryButtonText = "Check Eligibility",
  onPrimaryClick,
  onSecondaryClick,
}) {
  return (
    <section
      id="loan-hero"
      className="relative overflow-hidden bg-gradient-to-br from-slate-50 via-white to-primary/5"
    >
      <div className="container mx-auto px-6 py-20 lg:py-28">
        <div className="grid lg:grid-cols-2 gap-14 items-center">
          <div>
            {badge && (
              <div className="inline-flex items-center rounded-full border bg-primary/5 px-4 py-2 text-sm font-medium text-primary mb-6">
                {badge}
              </div>
            )}

            <h1 className="text-4xl md:text-5xl xl:text-6xl font-bold tracking-tight text-slate-900 leading-tight">
              {title}
            </h1>

            <p className="mt-6 text-lg text-slate-600 leading-8 max-w-xl">
              {description}
            </p>

            <div className="mt-8 grid gap-4">
              {highlights.map((item) => (
                <div key={item} className="flex items-center gap-3">
                  <CheckCircle2 className="h-5 w-5 text-green-600 shrink-0" />

                  <span className="text-slate-700">{item}</span>
                </div>
              ))}
            </div>

            <div className="mt-10 flex flex-wrap gap-4">
              <Button onClick={onPrimaryClick}>
                {primaryButtonText}
                <ArrowRight className="ml-2 h-5 w-5" />
              </Button>

              <Button variant="outline" onClick={onSecondaryClick}>
                {secondaryButtonText}
              </Button>
            </div>
          </div>

          <div>
            <img src={image} alt={title} className="w-full max-w-xl mx-auto rounded-xl shadow-xl shadow-blue-500/10" />
          </div>
        </div>
      </div>
    </section>
  );
}
